import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button } from "../components/kit";
import api, { formatApiErrorDetail } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we'll send a reset link." testId="forgot-page">
      {sent ? (
        <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          <div data-testid="forgot-confirm" style={{ padding: "var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--surface-brand-wash)", color: "var(--buktu-green-deep)", font: "var(--type-body-sm)" }}>
            If that email is registered, a reset link has been sent. It expires in one hour.
          </div>
          <Link to="/login" data-testid="forgot-back-link" style={{ color: "var(--text-link)", font: "var(--type-body-sm)" }}>← Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
          {error && <div style={errStyle}>{error}</div>}
          <label style={lbl}>Email
            <input data-testid="forgot-email" className="buktu-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@business.com" required />
          </label>
          <Button type="submit" full size="lg" data-testid="forgot-submit" disabled={loading}>
            {loading ? "Sending…" : "Send reset link"}
          </Button>
          <Link to="/login" data-testid="forgot-back-link" style={{ color: "var(--text-link)", font: "var(--type-body-sm)", textAlign: "center" }}>← Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}

const lbl = { display: "flex", flexDirection: "column", gap: "var(--space-2)", font: "var(--type-label)", color: "var(--text-strong)" };
const errStyle = { padding: "var(--space-3) var(--space-4)", borderRadius: "var(--radius-md)", background: "var(--status-risk-soft)", color: "#8a2a1a", font: "var(--type-body-sm)", fontSize: 13 };
